import React from 'react';
import PropTypes from 'prop-types';
import {Collapse} from "reactstrap";
import assets from "../../../../../util/assets";
import EmptyComponent from "../../../../empty";

HomeScreenEmptyContainer.propTypes = {
    get_content_list: PropTypes.object.isRequired,
    contentList: PropTypes.array.isRequired,
};

function HomeScreenEmptyContainer(props) {
    return (
        <Collapse isOpen={!props.get_content_list.isFetching && props.contentList.length === 0}>
            <EmptyComponent
                img={assets.empty.content_zero}
                title={" No results found"}
                description={"Sorry there is no content found at this moment. Try using search to find what you are looking for"}/>
        </Collapse>
    );
}

export default HomeScreenEmptyContainer;